import React from "react";
import styled from "styled-components";

const Pulse = styled.div`
  position: absolute;
  right: ${({ right }) => right};
  top: ${({ top }) => top};
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.theme.colors.teal};
  box-shadow: 0 0 0 ${props => props.theme.colors.teal};
  animation: pulse 2s infinite;

  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 ${props => props.theme.colors.teal};
    }
    70% {
      -webkit-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 ${props => props.theme.colors.teal};
      box-shadow: 0 0 0 0 ${props => props.theme.colors.teal};
    }
    70% {
      -moz-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);
      box-shadow: 0 0 0 15px rgba(204, 169, 44, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
      box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    }
  }
`;

export default ({ top = "", right = "" }) => <Pulse top={top} right={right} />;



// WEBPACK FOOTER //
// ./src/components/atoms/Pulse.js